var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"depressed":"","color":"primary","type":_vm.type,"loading":_vm.loading,"block":_vm.block,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }